"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNRError = exports.isNAError = exports.mathScope = exports.NOT_REPORTED = exports.NOT_APPLICABLE = void 0;
// Copied from api `rules/calculation/formula.ts`; keep results identical, SDG calculations still use that copy
exports.NOT_APPLICABLE = 'not_applicable';
exports.NOT_REPORTED = 'not_reported';
const NOT_REPORTING_DEFAULT_VALUE = 0;
const NOT_APPLICABLE_DEFAULT_VALUE = 0;
exports.mathScope = Object.freeze({
    resolveString: (testVariable, testValue, onSuccess = 1, onFail = 0) => {
        if (testVariable === testValue) {
            return onSuccess;
        }
        if (testVariable === exports.NOT_APPLICABLE) {
            throw Error('Undefined symbol not_applicable');
        }
        if (testVariable === exports.NOT_REPORTED) {
            throw Error('Undefined symbol not_reported');
        }
        return onFail;
    },
    linearDistribution: (testVariable, minInput, maxInput, minOutput, maxOutput) => {
        if (!isFinite(testVariable)) {
            // deals with xxx/0 === 'Infinity'
            testVariable = 0;
        }
        const value = Math.max(Math.min(testVariable, maxInput), minInput);
        const valuePc = (100 * (value - minInput)) / (maxInput - minInput);
        const outputPcIncrement = (maxOutput - minOutput) / 100;
        return valuePc * outputPcIncrement;
    },
    resolveNaNr: (testVariable, ifNa = NOT_APPLICABLE_DEFAULT_VALUE, ifNr = NOT_REPORTING_DEFAULT_VALUE, ifElse) => {
        if (testVariable === exports.NOT_APPLICABLE) {
            return ifNa;
        }
        if (testVariable === exports.NOT_REPORTED) {
            return ifNr;
        }
        if (ifElse !== undefined) {
            return ifElse;
        }
        return isNaN(testVariable) ? testVariable : Number(testVariable);
    },
    ifNA: (testVariable, ifTrue, ifFalse) => {
        if (testVariable === exports.NOT_APPLICABLE) {
            return ifTrue;
        }
        if (ifFalse !== undefined) {
            return ifFalse;
        }
        return isNaN(testVariable) ? testVariable : Number(testVariable);
    },
    ifNR: (testVariable, ifTrue, ifFalse) => {
        if (testVariable === exports.NOT_REPORTED) {
            return ifTrue;
        }
        if (ifFalse !== undefined) {
            return ifFalse;
        }
        return isNaN(testVariable) ? testVariable : Number(testVariable);
    },
});
const isNAError = (e) => {
    switch (e.message) {
        case 'Undefined symbol not_applicable':
        case 'Cannot convert "not_applicable" to a number':
            return true;
    }
    return false;
};
exports.isNAError = isNAError;
const isNRError = (e) => {
    switch (e.message) {
        case 'Undefined symbol not_reported':
        case 'Cannot convert "not_reported" to a number':
            return true;
    }
    return false;
};
exports.isNRError = isNRError;
